import styled from '@emotion/styled'

export const ControlBar = styled.div`
  background: ${({ theme }) => theme.gray4};
  box-shadow: 0 2px 0 0 ${({ theme }) => theme.gray4};
  padding: 4px 2px;
  display: flex;
`
